import Cookies from "js-cookie";

/* eslint-disable-next-line */
(window as any).LanguageSelector = {
  opts: {
    cookieName: "current-locale",
    cookieExpire: 365 * 10,
    cookieDomain: "",
    languageSelectorClass: ".language-selector",
  },

  init: function () {
    this.langSelectorToggle = document.getElementById("language-selector-toggle");
    this.langSelector = document.querySelector(this.opts.languageSelectorClass);

    /* eslint-disable-next-line */
    const loadedLocale = (window as any).LANG_STRINGS["locale"].toLowerCase();

    const savedLocale = this.getCookieLocale();
    const firstUrlSegment = this.getFirstUrlSegment().toLowerCase();

    // This means the default locale was loaded because locale in url is missing or invalid
    if (loadedLocale !== firstUrlSegment) {
      if (savedLocale) {
        window.location.replace("/" + savedLocale + "/");
      } else {
        window.location.replace("/" + loadedLocale + "/");
      }
    }

    this.setListeners();
  },

  setListeners: function () {
    if (this.langSelectorToggle) {
      this.langSelectorToggle.addEventListener("click", (e: Event) => {
        e.preventDefault();
        if (this.langSelector) {
          this.langSelector.classList.toggle("open");
          const languageList = document.querySelector(".language-list");
          if (languageList) {
            languageList.scrollTop = 0;
          }
        }
      });
    }

    document.body.addEventListener("click", (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (this.langSelector && 
          target !== this.langSelector && 
          !target.closest(this.opts.languageSelectorClass)) {
        this.langSelector.classList.remove("open");
      }
    });

    const languageElements = document.querySelectorAll(".language");
    languageElements.forEach(element => {
      element.addEventListener("click", (e: Event) => {
        e.preventDefault();
        const locale = (element as HTMLElement).dataset.locale;
        if (locale) {
          this.setCookieLocale(locale);
          window.location.replace("/" + locale + "/");
        }
      });
    });
  },

  getFirstUrlSegment: function () {
    const pathArray = window.location.pathname.split("/");
    return pathArray.length >= 2 ? pathArray[1] : undefined;
  },

  getCookieLocale: function () {
    return Cookies.get(this.opts.cookieName);
  },

  setCookieLocale: function (value: string) {
    // Set "site default" cookie to global value
    Cookies.set(this.opts.cookieName, value, {
      expires: this.opts.cookieExpire,
    });
  },
};

document.addEventListener("DOMContentLoaded", () => {
  /* eslint-disable-next-line */
  if ((window as any).LANG_STRINGS) {
    /* eslint-disable-next-line */
    (window as any).LanguageSelector.init();
  }
});
